import { Card, CardBody, Col, Row, Table } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { isEmpty, map } from "lodash";
import { Link } from "react-router-dom";
import React from "react";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";
import logo from "../../../../../assets/images/brands/MobihunterDark.png";
import PreloaderData from "../../../../../components/PreloaderData";
import CustomMiniLoader from "../../../../../components/CustomMiniLoader/CustomMiniLoader";
import { showInfoMessage } from "../../../../../helpers/utils";
import SweetAlert from "react-bootstrap-sweetalert";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import html2PDF from "jspdf-html2canvas";
import { axiosApi, get } from "../../../../../helpers/api_helper";
import InvoiceTemplate1 from "./template1";
import TemplateDefault from "./templateDefault";
import InvoiceTemplate2 from "./template2";
import InvoiceTemplate3 from "./template3";
// import html2pdf from "html2pdf.js";

const InvoiceProfileBlock = ({
  invoiceData,
  loader,
  makeLoader,
  updateInvoice,
  permissions,
}) => {
  const { contractor, payment_description, classification, total_in_custom_currency, template } = invoiceData;

  const [prev, setPrev] = React.useState("");
  const [infoAlert, setInfoAlert] = React.useState(false);
  const [infoData, setInfoData] = React.useState(null);
  const [base64Image, setBase64Image] = React.useState("");

  const [e, setE] = React.useState(false)

  const langUA = total_in_custom_currency?.includes("UAH") ? true : false;

  React.useEffect(() => {

    if (invoiceData?.supplier_signature) {
      handleFetchImage(invoiceData?.supplier_signature);
    }

    return () => {
      setPrev("");
      setBase64Image("")
    };

  }, [invoiceData?.supplier_signature]);

  // React.useEffect(() => {
  //   if (invoiceData.suplier_signature) {
  //     // convertFromURLToFile(invoiceData.supplier_signature);
  //     // convertFromURLToFile(invoiceData.suplier_signature)
  //     // setPrev(invoiceData.suplier_signature);
  //   }
  //   return () => {
  //     setPrev("");
  //   };
  // }, []);

  const handleFetchImage = img => {
    const fetchImage = async () => {
      try {
        const response = await fetch(img);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          setBase64Image(base64String);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchImage();
  };

  const notCustomColls = [
    {
      Header: template?.data?.type ?  template?.data?.type : langUA ? "Опис" : "Type",
      accessor: "type", // "title",
      style: {
        textAlign: "center",
        width: "auto",
        verticalAlign: "middle",
      },
    },
    {
      Header:  template?.data?.period ? template?.data?.period : langUA ? "Кількість годин" : "Period",
      accessor: "period", //"supplier_additional_info",
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
    {
      Header: template?.data?.amount ? template?.data?.amount  : langUA ? "Сума" : "Amount",
      accessor: "total",
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
  ]

  const ClientColls = [
    {
      Header: template?.data?.type ? template?.data?.type : langUA ? "Опис" : "Type",
      accessor: "title", // "title",
      style: {
        textAlign: "center",
        width: "auto",
        verticalAlign: "middle",
      },
    },
    {
      Header: template?.data?.period  ? template?.data?.period  : langUA ? "Кількість годин" : "Period",
      // accessor: "period", //"supplier_additional_info",
      accessor: row => (
        <span
        >
          {row.date_from} - {row.date_to}
        </span>
      ),
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
    {
      Header: template?.data?.amount  ? template?.data?.amount : langUA ? "Сума" : "Amount",
      // accessor: "unit_price",
      accessor: "custom_unit_price",
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
  ];

  const SalaryColls = [
    {
      Header: "Type",
      accessor: "title", // "title",
      style: {
        textAlign: "center",
        width: "auto",
        verticalAlign: "middle",
      },
    },
    {
      Header: "Period",
      accessor: "period", //"supplier_additional_info",
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
    {
      Header: "Amount",
      accessor: "unit_price",
      style: {
        textAlign: "center",
        width: "30%",
        verticalAlign: "middle",
      },
    },
  ];

  const handleChangeTable = () => {
    console.log();
  };

  //Print the Invoice
  const printInvoice = () => {
    window.print();
  };

  // const table_data = [
  //   {
  //     type: invoiceData?.payment_description,
  //     period: invoiceData?.period,
  //     total: invoiceData?.total,
  //   },
  // ];


  const table_data = [
    {
      type: invoiceData?.payment_description,
      period: invoiceData?.period,
      total: invoiceData?.total_in_custom_currency,
    },
  ];

  const SalaryTable = () => {
    let table = invoiceData?.items.map(i => {
      return {
        title: i?.title,
        period: invoiceData?.period,
        unit_price: i?.unit_price,
      };
    });

    return [
      ...table,
      {
        title: "Total",
        period: "",
        unit_price: invoiceData?.total,
      },
    ];
  };

  const handleStatusPaid = status => {
    switch (status) {
      case "NEW":
        return {
          bg: "success",
          label: "Make paid",
        };
      case "PAID":
        return {
          bg: "primary",
          label: "Make new",
        };
      default:
        return {
          bg: "success",
          label: "Make paid",
        };
    }
  };

  // const handleUpdateStatus = status => {
  //   switch (status) {
  //     case "NEW":
  //       return updateInvoice(invoiceData.id, { status: "PAID" });
  //     case "PAID":
  //       return updateInvoice(invoiceData.id, { status: "NEW" });
  //     default:
  //       return showInfoMessage("Unknown status");
  //   }
  // };

  const onClickStatus = status => {
    let dt = {};
    switch (status) {
      case "NEW":
        dt["status"] = "PAID"; //updateInvoice(invoiceData.id, { status: "PAID" });
        break;
      case "PAID":
        dt["status"] = "NEW";
        break;
      default:
        break;
    }

    const data = {
      status: dt.status,
      onConfirm: () => {
        updateInvoice(invoiceData.id, dt);
        setInfoAlert(false);
      },
    };

    setInfoData(data);
    setInfoAlert(!infoAlert);
  };

  const onButtonClick = async () => {
    var data = document.getElementById("pdf--exporter");
    const pdf = await html2PDF(data, {
      imageType: "image/png",
      imageQuality: 1,
      output: `Invoice-#${invoiceData.number}.pdf`,
      html2canvas: {
        scale: 1.7,
        windowWidth: 1200,
        imageTimeout: 15000,
        logging: true,
        // useCors: false,
        // proxy: invoiceData.supplier_signature,
      },
      jsPDF: {
        // orientation: "p",
        // unit: "mm",
        format: "a4",
        // putOnlyUsedFonts: true,
        // floatPrecision: 16,
      },
      margin: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1,
      },
    });
    setE(false)
  };

  const grandTotalWithTax = (number, percentage) => {
    let sum = (percentage / 100) * number;
    return (Number(number) + Number(sum)).toFixed(2);
  };

  return (
    <React.Fragment>
      {infoAlert && (
        <SweetAlert
          showCancel
          confirmBtnText="Change"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="success"
          title="Change paid status"
          onCancel={() => setInfoAlert(!infoAlert)}
          onConfirm={infoData.onConfirm}
        >
          {`Are you sure you want to change the current invoice status? `}
        </SweetAlert>
      )}

      {!loader ? (
        <>
          {!isEmpty(invoiceData) && (
            <Row className="fade-in-custom-animate">
              <Col lg="12">
                <Card>
                  <CardBodyStyled id="pdf--exporter">
                    <div
                      className="invoice-title d-flex align-items-center justify-content-between"
                      data-html2canvas-ignore="true"
                    >
                      <div className="">
                        <img src={logo} alt="logo" height="30" />
                      </div>
                      <div className="float-end">
                        {makeLoader ? (
                          <CustomMiniLoader
                            status
                            text="Status updating, please wait"
                          />
                        ) : (
                          <>
                            {permissions["change_invoice"] && (
                              <button
                                type="submit"
                                onClick={() =>
                                  onClickStatus(invoiceData.status)
                                }
                                className={`btn btn-${handleStatusPaid(invoiceData.status)?.bg
                                  } save-user no-print`}
                              >
                                {handleStatusPaid(invoiceData.status)?.label}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <hr data-html2canvas-ignore="true" />
                    {/* START FROM HERE */}
                    {template?.data?.template == 14 && (
                      <InvoiceTemplate1
                        classification={classification}
                        table_data={table_data}
                        notCustomColls={notCustomColls}
                        ClientColls={ClientColls}
                        handleChangeTable={handleChangeTable}
                        total_in_custom_currency={langUA ? total_in_custom_currency?.split(" ")[0] + " ГРН" : total_in_custom_currency}
                        invoiceData={invoiceData}
                        base64Image={base64Image}
                        langUA={langUA}
                        grandTotalWithTax={grandTotalWithTax}
                        valuesTemplate={template?.data}
                        with_signature
                        demo
                      />
                    )}

                    {template?.data?.template == 15 && (
                      <InvoiceTemplate2
                        classification={classification}
                        table_data={table_data}
                        notCustomColls={notCustomColls}
                        ClientColls={ClientColls}
                        handleChangeTable={handleChangeTable}
                        total_in_custom_currency={langUA ? total_in_custom_currency?.split(" ")[0] + " ГРН" : total_in_custom_currency}
                        invoiceData={invoiceData}
                        base64Image={base64Image}
                        langUA={langUA}
                        valuesTemplate={template?.data}
                        grandTotalWithTax={grandTotalWithTax}
                        with_signature
                        demo
                      />
                    )}

                    {template?.data?.template == 16 && (
                      <InvoiceTemplate3
                        classification={classification}
                        table_data={table_data}
                        notCustomColls={notCustomColls}
                        ClientColls={ClientColls}
                        handleChangeTable={handleChangeTable}
                        total_in_custom_currency={langUA ? total_in_custom_currency?.split(" ")[0] + " ГРН" : total_in_custom_currency}
                        invoiceData={invoiceData}
                        base64Image={base64Image}
                        langUA={langUA}
                        valuesTemplate={template?.data}
                        with_signature
                        grandTotalWithTax={grandTotalWithTax}
                        demo
                      />
                    )}

                    {template == null && (
                      <TemplateDefault
                        classification={classification}
                        table_data={table_data}
                        notCustomColls={notCustomColls}
                        ClientColls={ClientColls}
                        handleChangeTable={handleChangeTable}
                        total_in_custom_currency={langUA ? total_in_custom_currency?.split(" ")[0] + " ГРН" : total_in_custom_currency}
                        invoiceData={invoiceData}
                        base64Image={base64Image}
                        langUA={langUA}
                        grandTotalWithTax={grandTotalWithTax}
                      />
                    )}

                    {/* END HERE */}
                    {permissions["change_invoice"] && (
                      <div
                        className="d-print-none"
                        data-html2canvas-ignore="true"
                      >
                        <div className="float-end">
                          <Link
                            to="#"
                            onClick={() => {
                              setE(true)
                              return onButtonClick()
                            }}
                            className="btn btn-success me-2"
                            id="save-pdf--tooltip"
                          >
                            Save
                            <i className="fa fa-save ms-2" />
                          </Link>
                          <Link
                            to="#"
                            onClick={printInvoice}
                            className="btn btn-success me-2"
                            id="print-pdf--tooltip"
                          >
                            Print
                            <i className="fa fa-print  ms-2" />
                          </Link>
                          <Link to="#" className="btn btn-primary w-md ">
                            Send
                          </Link>
                        </div>
                      </div>
                    )}
                  </CardBodyStyled>
                </Card>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <PreloaderData />
      )}
    </React.Fragment>
  );
};

const CardBodyStyled = styled(CardBody)`
  @media print {
    .no-print {
      display: none;
    }
  }
`;

const StyledImage = styled.div`
  background-image: url(${props => props.src});
  background-size: cover;
  width: 250px;
  height: 250px;
`;

const StyledRow = styled.div`
  margin-bottom: 20px;

  img {
    width: auto;
    height: 110px;
  }

  h4 {
    margin-left: 15px;
    margin-bottom: 0;
  }
`;

InvoiceProfileBlock.propTypes = {
  invoiceData: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired,
  updateInvoice: PropTypes.func.isRequired,
  makeLoader: PropTypes.bool,
  permissions: PropTypes.any,
};

export default InvoiceProfileBlock;